module.exports = __webpack_public_path__ + "img/tn.083e197.webp";